import { AppAuctionTypes } from '../AppAuction';

export const auctionItemSelectTitle: Record<AppAuctionTypes, string> = {
	[AppAuctionTypes.Realty]: 'Выберите недвижимость',
	[AppAuctionTypes.Vehicle]: 'Выберите транспорт',
	[AppAuctionTypes.Clothes]: 'Выберите одежду',
	[AppAuctionTypes.Bussiness]: 'Выберите бизнес',
};

export const auctionClothesPreviewItems: {
	id: string;
	name: string;
	variant: string;
}[] = [
	{ id: 'ccl_m_849', name: 'Кофта Анархист', variant: '(Красная)' },
	{ id: 'ccl_m_857', name: 'Кофта Анархист', variant: '(Чёрная)' },
	{ id: 'ccl_m_869', name: 'Кофта Анархист', variant: '(Серая)' },
	{ id: 'ccl_m_877', name: 'Рубашка классика', variant: '(Белая)' },
	{ id: 'ccl_m_886', name: 'Худи Street', variant: '(Синяя)' },
	{ id: 'ccl_m_898', name: 'Свитер вязаный', variant: '(Бежевый)' },
	{ id: 'ccl_m_908', name: 'Лонгслив', variant: '(Оливковый)' },
	{ id: 'ccl_m_920', name: 'Пуловер', variant: '(Коричневый)' },
	{ id: 'ccl_m_929', name: 'Кардиган', variant: '(Тёмный)' },
	{ id: 'ccl_m_940', name: 'Футболка', variant: '(Графит)' },
	{ id: 'ccl_m_950', name: 'Ветровка', variant: '(Зелёная)' },
	{ id: 'ccl_m_952', name: 'Бомбер', variant: '(Чёрный)' },
];
